'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useRef } from 'react';
import {
  initializeSnapchatPixel,
  reportSnapchatAttribution,
  SNAPCHAT_ENABLED,
  trackSnapchatPageView,
} from '@/app/metrics';

export function SnapchatPixel() {
  // Tracking mounts outside LocaleIntlProviders, so use the native router hook.
  const pathname = usePathname();
  const lastPage = useRef<string | null>(null);
  useEffect(() => {
    if (!SNAPCHAT_ENABLED) return;
    initializeSnapchatPixel();
    reportSnapchatAttribution();
    if (lastPage.current !== pathname) {
      lastPage.current = pathname;
      trackSnapchatPageView();
    }
  }, [pathname]);
  if (!SNAPCHAT_ENABLED) return null;
  return (
    <Script
      id="snapchat-pixel"
      src="https://sc-static.net/scevent.min.js"
      strategy="lazyOnload"
      onReady={reportSnapchatAttribution}
    />
  );
}
